document.addEventListener("DOMContentLoaded",function(){document.querySelectorAll(".gmv-footer .footer-menu-item a").forEach(function(e){e.style.pointerEvents="auto",e.style.cursor="pointer",e.style.position="relative",e.style.zIndex="100",e.addEventListener("click",function(e){if(this.href&&"#"!==this.href&&""!==this.href)return!0;e.preventDefault()}),e.addEventListener("mouseenter",function(){this.style.opacity="0.8",this.style.textDecoration="underline"}),e.addEventListener("mouseleave",function(){this.style.opacity="1",this.style.textDecoration="none"})}),document.querySelectorAll(".gmv-footer .social-link").forEach(function(e){e.style.pointerEvents="auto",e.style.cursor="pointer",e.style.position="relative",e.style.zIndex="100",e.addEventListener("click",function(e){if(this.href&&"#"!==this.href&&""!==this.href)return!0;e.preventDefault()})}),document.querySelectorAll(".gmv-footer .footer-bottom-link").forEach(function(e){e.style.pointerEvents="auto",e.style.cursor="pointer",e.style.position="relative",e.style.zIndex="100",e.addEventListener("click",function(e){if(this.href&&"#"!==this.href&&""!==this.href)return!0;e.preventDefault()})})});

/* === Extracted from inline === */
document.addEventListener('DOMContentLoaded', function () {
    // Country selector functionality
    const countryBtn = document.getElementById('gmv-country-selector-btn');
    const countryPopup = document.getElementById('gmv-country-popup');
    const countryClose = document.getElementById('gmv-country-close');
    const countryOptions = document.querySelectorAll('.gmv-country-option');
    const countryForm = document.getElementById('gmv-country-form');
    const countryInput = document.getElementById('gmv-country-input');

    // Language selector functionality
    const languageBtn = document.getElementById('gmv-language-selector-btn');
    const languagePopup = document.getElementById('gmv-language-popup');
    const languageClose = document.getElementById('gmv-language-close');
    const languageOptions = document.querySelectorAll('.gmv-language-option');

    console.log('Language selector elements:', {
      languageBtn,
      languagePopup,
      languageClose,
      languageOptionsCount: languageOptions.length,
    });

    // Open country popup
    countryBtn.addEventListener('click', function () {
      countryPopup.style.display = 'flex';
    });

    // Close country popup
    countryClose.addEventListener('click', function () {
      countryPopup.style.display = 'none';
    });

    // Close popup when clicking outside
    countryPopup.addEventListener('click', function (e) {
      if (e.target === countryPopup) {
        countryPopup.style.display = 'none';
      }
    });

    // Handle country selection via Shopify localization form
    countryOptions.forEach(function (option) {
      option.addEventListener('click', function (e) {
        e.preventDefault();
        var countryCode = this.getAttribute('data-country');
        if (!countryCode) return;

        countryPopup.style.display = 'none';

        var locInput = document.getElementById('gmv-country-code-input');
        var locForm = document.getElementById('gmv-country-localization-form');

        if (locInput && locForm) {
          locInput.value = countryCode;
          locForm.submit();
        } else {
          var currentUrl = new URL(window.location.href);
          currentUrl.searchParams.set('country', countryCode);
          window.location.href = currentUrl.toString();
        }
      });
    });

    // Open language popup
    if (languageBtn && languagePopup) {
      languageBtn.addEventListener('click', function () {
        console.log('Language button clicked');
        languagePopup.style.display = 'flex';
      });
    }

    // Close language popup
    if (languageClose && languagePopup) {
      languageClose.addEventListener('click', function () {
        languagePopup.style.display = 'none';
      });
    }

    // Close popup when clicking outside
    if (languagePopup) {
      languagePopup.addEventListener('click', function (e) {
        if (e.target === languagePopup) {
          languagePopup.style.display = 'none';
        }
      });
    }

    // Handle language selection (using the same approach as gmv-header)
    if (languageOptions && languageOptions.length > 0) {
      languageOptions.forEach(function (option) {
        option.addEventListener('click', function (e) {
          e.preventDefault();
          const langCode = this.getAttribute('data-lang');

          console.log('Language selected:', langCode);

          if (!langCode) {
            console.error('No language code found');
            return;
          }

          // Close popup
          if (languagePopup) {
            languagePopup.style.display = 'none';
          }

          // Save language preference to localStorage (same as header does)
          const displayText = langCode === 'it' ? 'IT' : 'ENG';
          localStorage.setItem('selectedLanguage', langCode);
          localStorage.setItem('selectedLanguageText', displayText);

          // Set session flags to prevent automatic IP-based redirection
          sessionStorage.setItem('gmv-popupDisplayedAfterRedirect', 'true');
          sessionStorage.setItem('popupDisplayedAfterRedirect', 'true');

          // Also set the gmv-lang to match
          localStorage.setItem('gmv-lang', langCode);
          localStorage.setItem('lang', langCode);

          console.log('Saved language preference:', langCode, displayText);
          console.log('Set session flags to prevent auto-redirect');

          // Use the same URL redirection as the header
          const currentPath = window.location.pathname;
          const currentSearch = window.location.search;
          const currentHash = window.location.hash;

          // Remove existing language prefix if present
          const pathWithoutLang = currentPath.replace(/^\/en/, '') || '/';

          let newPath;
          if (langCode === 'it') {
            // Italian is default - no prefix needed
            newPath = pathWithoutLang;
          } else if (langCode === 'en') {
            // English needs /en prefix
            newPath = `/en${pathWithoutLang}`;
          }

          const newURL = newPath + currentSearch + currentHash;

          console.log('Current path:', currentPath);
          console.log('New path:', newPath);
          console.log('Redirecting to:', newURL);

          // Only redirect if URL actually changes
          if (window.location.pathname !== newPath) {
            window.location.href = newURL;
          }
        });
      });
    }

    // ESC key to close popups
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        if (countryPopup) countryPopup.style.display = 'none';
        if (languagePopup) languagePopup.style.display = 'none';
      }
    });
  });

  // LocalizationForm custom element (from original footer.liquid)
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };

      if (this.elements.button) {
        this.elements.button.addEventListener('click', this.openSelector.bind(this));
        this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      }

      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      if (this.elements.button && this.elements.panel) {
        this.elements.button.setAttribute('aria-expanded', 'false');
        this.elements.panel.setAttribute('hidden', true);
      }
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;
      this.hidePanel();
      if (this.elements.button) this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      if (this.elements.input) {
        this.elements.input.value = event.currentTarget.dataset.value;
      }
      this.querySelector('form')?.submit();
    }

    openSelector() {
      if (this.elements.button && this.elements.panel) {
        this.elements.button.focus();
        this.elements.panel.toggleAttribute('hidden');
        this.elements.button.setAttribute(
          'aria-expanded',
          (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
        );
      }
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

